<template>
	<v-card class="sidebar">
		<v-card-title class="d-flex justify-space-between flex-nowrap">
			<span>{{ title }}</span>
			<v-btn class="align-self-baseline" small icon @click="$emit('close')"
				><v-icon>fas fa-times</v-icon></v-btn
			>
		</v-card-title>

		<v-card-text>
			<slot />
		</v-card-text>

		<slot name="actions" />
	</v-card>
</template>

<style lang="scss" scoped>
.sidebar {
	min-height: 100%;
}
</style>

<script>
export default {
	props: {
		title: String,
	},
};
</script>
